<template>
    <span>Redirecting...</span>
</template>

<script>
export default {
  props: {
    programmeId: { type: Number, required: true },
  },
  created() {
    window.location.href = `${process.env.VUE_APP_WEBAPP_BASE_URL}/programmes/${this.programmeId}`;
  },
};
</script>
